import React from 'react';
import { Card, Avatar, Tooltip } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  LinkOutlined,
  CodeOutlined,
} from '@ant-design/icons';
import { Website } from '../../types';
import './styles.css';

type ActionCallback = (id: string) => void;

interface WebsiteCardProps {
  website: Website;
  onEdit: ActionCallback;
  onGetCode: ActionCallback;
  onViewStats: ActionCallback;
  onRemove: ActionCallback;
}

const WebsiteCard: React.FC<WebsiteCardProps> = ({
  website,
  onEdit,
  onGetCode,
  onViewStats,
  onRemove,
}) => {
  const { id, title, url } = website;
  const avatar = title.charAt(0);

  const handleEdit = () => {
    onEdit(id);
  };

  const handleGetCode = () => {
    onGetCode(id);
  };

  const handleRemove = () => {
    onRemove(id);
  };

  const handleViewStats = (e: React.MouseEvent) => {
    onViewStats(id);
  };

  return (
    <Card
      hoverable={true}
      className={'ant-card--website'}
      bordered={false}
      actions={[
        <Tooltip key={'edit'} title={'Edit website'}>
          <EditOutlined onClick={handleEdit} />
        </Tooltip>,
        <Tooltip key={'code'} title={'Get code'}>
          <CodeOutlined onClick={handleGetCode} />
        </Tooltip>,
        <Tooltip key={'delete'} title={'Delete website'}>
          <DeleteOutlined onClick={handleRemove} />
        </Tooltip>,
      ]}
    >
      <span onClick={handleViewStats}>
        <Card.Meta
          avatar={<Avatar>{avatar}</Avatar>}
          title={title}
          description={
            <div className="ant-card__link">
              <LinkOutlined /> {url}
            </div>
          }
        />
      </span>
    </Card>
  );
};

export default WebsiteCard;
